import type { z } from 'zod'
import { type ReactNode } from 'react'
import { CompanyCardSchema, type CompanyData } from '@terros/common'
import { type UseFormReturnType } from '@mantine/form'
import { Stack } from '@mantine/core'
import { ReviewFields } from './ReviewFields'
import { OurWorkFields } from './OurWorkFields'
import { MessageTemplateFields } from './MessageTemplateFields'
import { ContentFields } from './ContentFields'
import { BrandingFields } from './BrandingFields'

export const CompanyCardFormValuesSchema = CompanyCardSchema.pick({
  slug: true,
  links: true,
  attachmentIds: true,
  theme: true,
  sections: true,
  imageSource: true,
  maxImagesPerCard: true,
  starThreshold: true,
  teamInboxEmail: true,
  notifyManager: true,
  messageTemplates: true,
  placeId: true,
})
export type CompanyCardFormValues = z.infer<typeof CompanyCardFormValuesSchema> & {
  feedbackInboxEnabled: boolean
}

export type CompanyCardFormProps = {
  form: UseFormReturnType<CompanyCardFormValues>
}

export type CompanyCardFieldsProps = CompanyCardFormProps & {
  company: CompanyData
  placeLabel?: string
}

export const CompanyCardFields = ({ company, form, placeLabel }: CompanyCardFieldsProps): ReactNode => {
  return (
    <Stack gap='xl'>
      <BrandingFields company={company} form={form} />
      <ContentFields form={form} />
      <OurWorkFields form={form} />
      <ReviewFields form={form} placeLabel={placeLabel} />
      <MessageTemplateFields form={form} />
    </Stack>
  )
}
